import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  table: {
    marginBottom: theme.spacing(10),
    marginTop: '1%',
    marginLeft: '1%',
    marginRight: '1%',
  },
  columnAction: {
    width: '1%',
    paddingRight: theme.spacing(1),
  },
  container: {
    marginTop: theme.spacing(2),
  },
  buttons: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-evenly',
    '& > *': {
      flexBasis: '33%',
    },
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    paddingBottom: theme.spacing(3),
  },
  verticalActions: {
    display: 'flex',
    flexDirection: 'column',
  },
  success: {
    backgroundColor: theme.palette.success.main,
    color: '#fff',
  },
  warning: {
    backgroundColor: theme.palette.warning.main,
    color: '#fff',
  },
  secondary: {
    backgroundColor: theme.palette.secondary.main,
    color: '#fff',
  },
  error: {
    backgroundColor: theme.palette.error.main,
    color: '#fff',
  },
  // Dashboard
statCard: {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(2),
  borderRadius: theme.spacing(2),
  background: "linear-gradient(to right, #2196f3, #21cbf3)",
  color: "#fff",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
},
statIcon: {
  fontSize: 36,
  opacity: 0.9,
},
statTextContainer: {
  textAlign: "right",
},
statValue: {
  fontWeight: "bold",
  fontSize: 22,
},
formContainer: {
  padding: theme.spacing(3),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  marginBottom: theme.spacing(3),
},
formHeader: {
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(3),
},
formTitle: {
  flexGrow: 1,
},
formContent: {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
  gap: theme.spacing(3),
},
formSection: {
  gridColumn: '1 / -1', // Ocupa todas as colunas
  marginBottom: theme.spacing(3),
},
formField: {
  marginBottom: theme.spacing(2),
},
formActions: {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: theme.spacing(2),
  marginTop: theme.spacing(3),
  gridColumn: '1 / -1', // Ocupa todas as colunas
},
}));
